module.exports = __webpack_public_path__ + "img/composition-razor-animation.2141fcf6.gif";